import React, {useContext, useMemo} from 'react';
import LogTemplate from "./LogTemplate";
import {AuthContext} from "../../shared/contexts/authContext";
import GoToUserInfoButton from "../../shared/components/buttons/GoToUserInfoButton";
import {useItemKrTextData, usePackageDataTable} from "../probability/useItemData";
import IsLoading from "../../shared/components/IsLoading";
import ErrorPage from "../../shared/components/ErrorPage";
import {getPaymentLogColumns} from "./columns/paymentLogColumns";
import dayjs from "dayjs";
import {internalApi} from "../../common/axios";
import {buildUrl} from "../../shared/utils/net";
import {Space, Tag} from "antd";

const PaymentLog = () => {
    const {currentUser} = useContext(AuthContext);
    const searchParams = useMemo(() => ({
        begin: dayjs().subtract(1, "week").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        logType: 'payment_log',
        isUnix: false,
    }), []);

    const {data: krItemTextData, isLoading: isKrItemTextDataLoading, error: krItemTextDataError} = useItemKrTextData();
    const {data: packageData, isLoading: isPackageDataLoading, error: packageDataError} = usePackageDataTable();

    const paramTypeList = [
        {label: '전체', value: ''},
        {label: 'PID', value: 'pId'},
        {label: '아이템 ID', value: 'itemId'},
        {label: 'orderID', value: 'orderId'}
    ];

    if (isKrItemTextDataLoading || isPackageDataLoading) return <IsLoading/>;
    const error = krItemTextDataError || packageDataError;
    if (error) return <ErrorPage error={error}/>;

    const columns = [
        {
            title: 'PID',
            dataIndex: 'pid',
            search: true,
        },
        {
            title: '닉네임',
            dataIndex: 'name',
            search: true,
        },
        ...getPaymentLogColumns(packageData, krItemTextData[currentUser.target]),
        {
            title: '국가',
            dataIndex: 'country',
        },
        {
            title: '유저 정보',
            dataIndex: 'pid',
            render: (pid) => <GoToUserInfoButton pid={pid} />,
        },
    ];

    return (
        <LogTemplate
            columns={columns}
            defaultSearchParams={searchParams}
            paramTypeList={paramTypeList}
            routerUrl={'/logs'}
            logName={'PaymentLog'}
        />
    );
};

export default PaymentLog;